import { RadiusProperties } from './types';

export const radiusRegex = /^(-?\d+px?\s+)?(-?\d+px?\s+)?(-?\d+px?\s+)?(-?\d+px)$/;

export const defaultRadius = {
  borderTopRight: '0px',
  borderTopLeft: '0px',
  borderBottomRight: '0px',
  borderBottomLeft: '0px',
};

export const parseRadiusValue = (str: string): RadiusProperties => {
  const match = str.match(radiusRegex);
  if (!match) {
    return defaultRadius;
  }

  const [borderTopLeft, borderTopRight, borderBottomRight, borderBottomLeft] = match
    .slice(1, 6)
    .map((val) => (val ? val.trim() : val));

  if (borderBottomLeft && !borderTopLeft && !borderTopRight && !borderBottomRight) {
    return {
      borderTopRight: borderBottomLeft,
      borderBottomRight: borderBottomLeft,
      borderTopLeft: borderBottomLeft,
      borderBottomLeft,
    };
  }

  if (borderTopLeft && borderBottomLeft && !borderBottomRight && !borderTopRight) {
    return {
      borderTopRight: borderBottomLeft,
      borderBottomRight: borderTopLeft,
      borderTopLeft,
      borderBottomLeft,
    };
  }

  if (borderTopLeft && borderBottomLeft && borderTopRight && !borderBottomRight) {
    return {
      borderTopRight,
      borderTopLeft,
      borderBottomRight: borderBottomLeft,
      borderBottomLeft: borderTopRight,
    };
  }

  return {
    borderTopRight,
    borderBottomRight,
    borderTopLeft,
    borderBottomLeft,
  };
};

export const renderRadiusProperties = ({
  borderTopRight,
  borderTopLeft,
  borderBottomRight,
  borderBottomLeft,
}: RadiusProperties) =>
  `${borderTopLeft} ${borderTopRight} ${borderBottomRight} ${borderBottomLeft}`;

const pixelValueRegex = /^(-?\d+px)$/;

export const wrapPixelValue = (str: string) => (pixelValueRegex.test(str) ? str : '0px');
